var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 2048,
    height: 2048,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil3{fill:#B60C50}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1800 934v779c0 13-11 23-23 23H288c-13 0-23-11-23-23V934l728-505c22-15 60-14 83 2l726 503h-1z",
    style: {
      fill: "#FC2C51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8d0"
    },
    d: "M392 576h1280v838H392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121 1200c-30 35-72 59-119 59h-10c-43-3-79-26-104-61-24-33-36-73-38-113v-15c0-6 0-12 1-18 4-51 22-102 55-141 31-36 73-62 122-62h10c37 3 70 21 94 48l3-48 58 3-19 309c-1 16 5 30 18 39 7 5 15 6 23 6 47-2 85-42 103-83 20-44 26-104 14-150v-2c-14-51-41-98-79-136-57-57-134-89-216-89-81 0-158 32-216 89-57 57-89 134-89 216 0 81 32 158 89 216 57 57 134 89 216 89 65 0 128-20 180-59l23-17v72l-7 4c-59 38-127 58-197 58-97 0-188-38-257-106-68-68-106-160-106-257s38-188 106-257c68-68 160-106 257-106s188 38 257 106c45 45 77 101 94 162v1c13 59 9 130-16 185-28 62-84 118-156 121-21 1-41-4-58-16-18-12-29-30-36-49zm-213-125c1 31 9 63 27 88 15 20 36 35 62 37h5c31 0 58-18 77-41 25-30 39-69 42-108v-19c-1-31-9-63-27-88-15-20-36-35-62-37h-5c-31 0-58 18-77 41-25 30-39 69-42 108v19z",
    style: {
      fill: "#37474f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "m268 1725 608-416-612-375v778c0 5 1 9 4 12zM1800 1713V934h-1l-616 378 613 413c2-4 4-8 4-12z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1797 1725c-4 7-12 11-20 11H288c-8 0-16-4-20-11l724-503c22-15 59-14 83 2l722 501z",
    style: {
      fill: "#FC2C51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h2048v2048H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1aa6570a74c4101f34a6275dec649b74.svg";
export { ForwardRef as ReactComponent };